<template>
	<div class="___none">
		<slot></slot>
	</div>
</template>
